import { All, SortDirection } from "../interfaces";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import {
  dataLoaded,
  dataRequested,
  receiveResultsFailure,
  updateFilter,
  updateSortOrder,
} from "../common/actions";
import { connect } from "react-redux";
import * as StructureChangeLevelOneComponent from "../components/StructureChange/StructureChangeLevelOne";
import * as StructureChangeLevelTwoComponent from "../components/StructureChange/StructureChangeLevelTwo";

export function mapStateToProps({ appState }: All) {
  return {
    appState: appState.structureChange,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    onStartRequest: () => {
      dispatch(dataRequested());
    },
    onResultSuccess: () => {
      dispatch(dataLoaded());
    },
    onResultFailure: (error: Error) => dispatch(receiveResultsFailure(error)),
    updateSort: (sortField: string, sortDirection: SortDirection) => {
      dispatch(updateSortOrder(sortField, sortDirection));
    },
    updateFilters: (filter: string, value: number[] | string | undefined) => {
      dispatch(updateFilter(filter, value));
    },
  };
}

export const StructureChangeLevelOne = connect(
  mapStateToProps,
  mapDispatchToProps,
)(StructureChangeLevelOneComponent.default);

export const StructureChangeLevelTwo = connect(
  mapStateToProps,
  mapDispatchToProps,
)(StructureChangeLevelTwoComponent.default);
